import Vue from 'vue'
import numeral from 'numeral'
import { dateFormat, dateOnlyFormat, dateFormatDisplay } from './time'

Vue.filter('dateFormat', (val) => {
  return dateFormat(val) || '-'
})

Vue.filter('dateOnlyFormat', (val) => {
  return dateOnlyFormat(val) || '-'
})

Vue.filter('date', (val) => {
  if (!val) return
  return dateFormatDisplay(val, '/') || '-'
})

// Vue.filter('datetime', (val) => {
//   return dateTimeFormat(val) || '-'
// })

Vue.filter('currency', (val) => (numeral(val).format('0,0.00')))
Vue.filter('number_comma', (val) => (numeral(val).format('0,0')))
Vue.filter('currency_unit', (val) => {
  if (!val) return
  const valInt = parseInt(val)
  if (valInt > 1000000) {
    return `${valInt.toString().slice(0, -6)} M`
  } else if (valInt > 1000) {
    return `${valInt.toString().slice(0, -3)} K`
  }
  return numeral(valInt).format('0,0')
})

